import $ from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

export default class EFOcats_event_iOS extends EFOcats_event_core {
  event() {
    const ua = window.navigator.userAgent.toLowerCase();

    if (ua.indexOf('iphone os') !== -1) {
      $(window).on('resize', event => {
        setTimeout(() => {
          this.$('.cat-wrapper').height(window.innerHeight);
          this.$('.cat-wrapper > .cat-container').scrollTop(this.$('.qa.action').eq(0)[0].offsetTop);
        }, 10);
      });
    }
  }
}
